export default __webpack_public_path__ + "static/media/edit.fde93199.svg";